import api, { ApiError } from '@/apis'
import { API_PREFIX } from '@/constants'

import { apiGetUserInfo } from './getUserInfo'

interface ServiceAreaResponse {
  isAvailable: boolean
  address: string
}

/** 배송 불가 지역 — 백엔드가 200(isAvailable:false)이 아니라 422 로 내려주는 코드 */
const NOT_IN_SERVICE_AREA_CODE = 'E422200'

/**
 * 대표 주소가 배송 서비스 지역인지 조회 어댑터.
 *
 * GET /user 의 지번 주소(`address`, 없으면 `pastAddress`)로
 * `GET /orders/availability?itemCategory=DELIVERY&isQuick=false&addressJibun=...` 를 호출해
 * 배송 가능 여부(boolean)를 반환한다. (CTA 는 주소 등록 여부 다음에 이 체크를 수행)
 *
 * 배송 불가 지역은 백엔드가 **422(E422200)** 로 내려주므로 false 로 정규화한다 (그 외 에러는 전파).
 * itemCategory=DELIVERY·isQuick=false 고정.
 */
export const apiCheckServiceArea = async (): Promise<boolean> => {
  const user = await apiGetUserInfo()
  const addressJibun = user.address || user.pastAddress
  if (!addressJibun) return false

  try {
    const data = await api.get<ServiceAreaResponse>(`${API_PREFIX.ORDER}/orders/availability`, {
      params: { itemCategory: 'DELIVERY', isQuick: false, addressJibun },
    })
    return data.isAvailable
  } catch (error) {
    if (error instanceof ApiError && error.code === NOT_IN_SERVICE_AREA_CODE) return false
    throw error
  }
}
